import apiClient from '../apiClient';
import { API_ENDPOINTS } from '../config';

const departmentRoleService = {
  // Department APIs
  getDepartments: async (params = {}) => {
    try {
      

      const url = API_ENDPOINTS.HR.DEPARTMENTS;
      

      const response = await apiClient.get(url, { params });
      
      

      return response.data;
    } catch (error) {
      
      throw error;
    }
  },

  getDepartmentById: async (id) => {
    try {
      

      const url = `${API_ENDPOINTS.HR.DEPARTMENTS}/${id}`;
      

      const response = await apiClient.get(url);
      

      return response.data;
    } catch (error) {
      
      throw error;
    }
  },

  createDepartment: async (data) => {
    try {
      

      const url = API_ENDPOINTS.HR.DEPARTMENTS;
      

      const response = await apiClient.post(url, data);
      

      return response.data;
    } catch (error) {
      
      throw error;
    }
  },

  updateDepartment: async (id, data) => {
    try {
      

      const url = `${API_ENDPOINTS.HR.DEPARTMENTS}/${id}`;
      

      const response = await apiClient.put(url, data);
      

      return response.data;
    } catch (error) {
      
      throw error;
    }
  },

  deleteDepartment: async (id) => {
    try {
      

      const url = `${API_ENDPOINTS.HR.DEPARTMENTS}/${id}`;
      

      const response = await apiClient.delete(url);
      
      

      return response;
    } catch (error) {
      
      throw error;
    }
  },

  // Bulk delete departments
  bulkDeleteDepartments: async (ids) => {
    // Log call with stack trace to detect duplicate invocations
    
    

    const url = `${API_ENDPOINTS.HR.DEPARTMENTS}/bulk-delete`;
    const response = await apiClient.post(url, { ids });
    // apiClient interceptor already returns response.data directly
    return response;
  },

  // Role APIs
  getRoles: async (params = {}) => {
    try {
      

      const url = API_ENDPOINTS.HR.ROLES;
      

      const response = await apiClient.get(url, { params });
      
      

      return response.data;
    } catch (error) {
      
      throw error;
    }
  },

  createRole: async (data) => {
    try {
      

      const url = API_ENDPOINTS.HR.ROLES;
      

      const response = await apiClient.post(url, data);
      

      return response.data;
    } catch (error) {
      
      throw error;
    }
  },

  updateRole: async (id, data) => {
    try {
      

      const url = `${API_ENDPOINTS.HR.ROLES}/${id}`;
      

      const response = await apiClient.put(url, data);
      

      return response.data;
    } catch (error) {
      
      throw error;
    }
  },

  deleteRole: async (id) => {
    try {
      

      const url = `${API_ENDPOINTS.HR.ROLES}/${id}`;
      

      const response = await apiClient.delete(url);
      
      
      

      return response;
    } catch (error) {
      
      throw error;
    }
  },

  // Manager APIs
  getManagers: async (params = {}) => {
    try {
      

      const url = API_ENDPOINTS.HR.MANAGERS;
      

      const response = await apiClient.get(url, { params });
      
      

      return response.data;
    } catch (error) {
      
      throw error;
    }
  },

  // Statistics APIs
  getDepartmentStats: async () => {
    try {
      

      const url = `${API_ENDPOINTS.HR.DEPARTMENTS}/stats`;
      

      const response = await apiClient.get(url);
      

      return response.data;
    } catch (error) {
      
      throw error;
    }
  },

  getRoleStats: async () => {
    try {
      

      const url = `${API_ENDPOINTS.HR.ROLES}/stats`;
      

      const response = await apiClient.get(url);
      

      return response.data;
    } catch (error) {
      
      throw error;
    }
  }
};

export default departmentRoleService;


